import React from 'react';
import { MultiSelect, Option } from '../../../../../../../components/ui/multi-select';
import { CollapsibleFilterBar } from './CollapsibleFilterBar';

const MISC_STATUS_TYPES = ['Available', 'Consumed', 'Shipped to NDT'] as const;

interface MiscFiltersState {
  status: string[];
  productionType: string[];
  partNumber: string[];
  manufacturer: string[];
}

interface MiscFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  filters: MiscFiltersState;
  onFilterChange: (key: keyof MiscFiltersState) => (value: string[]) => void;
  uniqueProductionTypes: string[];
  uniquePartNumbers: string[];
  uniqueManufacturers: string[];
  hasActiveFilters: boolean;
  filteredCount: number;
  onResetFilters: () => void;
}

export const MiscFilters: React.FC<MiscFiltersProps> = ({
  searchQuery,
  onSearchChange,
  filters,
  onFilterChange,
  uniqueProductionTypes,
  uniquePartNumbers,
  uniqueManufacturers,
  filteredCount,
  onResetFilters,
}) => {
  const statusOptions: Option[] = MISC_STATUS_TYPES.map((s) => ({ value: s, label: s }));
  const prodOptions: Option[] = uniqueProductionTypes.map((v) => ({ value: v, label: v }));
  const partOptions: Option[] = uniquePartNumbers.map((v) => ({ value: v, label: v }));
  const manuOptions: Option[] = uniqueManufacturers.map((v) => ({ value: v, label: v }));

  const activeFilterCount =
    filters.status.length +
    filters.productionType.length +
    filters.partNumber.length +
    filters.manufacturer.length;

  return (
    <CollapsibleFilterBar
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      searchPlaceholder="Search part, heat, lot, job, PO, location, notes..."
      activeFilterCount={activeFilterCount}
      filteredCount={filteredCount}
      filteredCountLabel="materials"
      onResetFilters={onResetFilters}
    >
      <MultiSelect
        options={statusOptions}
        selected={filters.status}
        onChange={onFilterChange('status')}
        placeholder="Status"
        isSearchable={false}
      />
      <MultiSelect
        options={prodOptions}
        selected={filters.productionType}
        onChange={onFilterChange('productionType')}
        placeholder="Production type"
      />
      <MultiSelect
        options={partOptions}
        selected={filters.partNumber}
        onChange={onFilterChange('partNumber')}
        placeholder="Part number"
      />
      <MultiSelect
        options={manuOptions}
        selected={filters.manufacturer}
        onChange={onFilterChange('manufacturer')}
        placeholder="Manufacturer"
      />
    </CollapsibleFilterBar>
  );
};
